import { postCreateExchangeRates } from '../api/postCreateExchangeRates';

const setPostCreateExchangeRates = (params) => {
    return async (dispatch, getState) => {
        try {
            await postCreateExchangeRates(params);
            window.location.replace('/settings/exchange-rates')
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setPostCreateExchangeRates
}